import { render, staticRenderFns } from "./parentAudio_1.0.vue?vue&type=template&id=5ed87962&scoped=true"
import script from "./parentAudio_1.0.vue?vue&type=script&lang=js"
export * from "./parentAudio_1.0.vue?vue&type=script&lang=js"
import style0 from "./parentAudio_1.0.vue?vue&type=style&index=0&id=5ed87962&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed87962",
  null
  
)

export default component.exports